import React from 'react';
import { Switch, Route } from 'react-router-dom';
import NotFoundPage from 'app/components/NotFoundPage';
import PrintLayout from 'app/components/shared/PrintLayout';
import MainLayoutDeprecated from 'app/components/deprecated/MainLayoutDeprecated';

import availabilityRoutes from './availability';
import bibsRoutes from './bibs';
import dashboardRoutes from './dashboard';
import searchRoutes from './search';
import usersRoutes from './users';
import holdsRoutes from './borrowing/holds';
import checkedoutRoutes from './borrowing/checkedout';
import accountMessagesRoutes from './borrowing/accountMessages';
import interlibraryLoansRoutes from './borrowing/interlibraryLoans';
import recentlyReturnedRoutes from './borrowing/recentlyReturned';
import finesRoutes from './borrowing/fines';
import commentsRoutes from './ugc/comments';
import quotationsRoutes from './ugc/quotations';
import summariesRoutes from './ugc/summaries';
import videosRoutes from './ugc/videos';
import eventsRoutes from './events';
import locationsRoutes from './locations';
import printRoutes from './print';
import widgetsRoutes from './widgets';

export default (
  <Switch>
    <Route path="/v2/print">
      <PrintLayout>{printRoutes}</PrintLayout>
    </Route>
    <Route>
      <MainLayoutDeprecated>
        <Switch>
          {availabilityRoutes}
          {accountMessagesRoutes}
          {bibsRoutes}
          {checkedoutRoutes}
          {commentsRoutes}
          {dashboardRoutes}
          {eventsRoutes}
          {locationsRoutes}
          {finesRoutes}
          {holdsRoutes}
          {interlibraryLoansRoutes}
          {quotationsRoutes}
          {recentlyReturnedRoutes}
          {searchRoutes}
          {summariesRoutes}
          {usersRoutes}
          {videosRoutes}
          {widgetsRoutes}
          <Route>
            <NotFoundPage />
          </Route>
        </Switch>
      </MainLayoutDeprecated>
    </Route>
  </Switch>
);
